import React from "react";
import Fade from "react-reveal/Fade";
import "./Sideward.scss";

import { ReactComponent as GitHub } from "../../assets/svg/github.svg";
import { ReactComponent as Ig } from "../../assets/svg/instagram.svg";
import { ReactComponent as LinkedIn } from "../../assets/svg/linkedin.svg";
// import { ReactComponent as CodePen } from "../../assets/svg/codepen.svg";

function Sideward() {
  return (
    <div className="sideward">
      <Fade left>
        <div className="left">
          <ol>
            <li>
              <a href="https://github.com/G-development">
                <GitHub width="20px" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/gvnncz/">
                <Ig />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/gio-cuo/">
                <LinkedIn />
              </a>
            </li>
            {/* <li>
              <a href="#">
                <CodePen />
              </a>
            </li> */}
          </ol>
        </div>
      </Fade>
      <Fade right>
        <div className="right">
          <ol>
            <li>
              <a href="mailto:cuozzogiovanni03@gmail.com">
                cuozzogiovanni03@gmail.com
              </a>
            </li>
          </ol>
        </div>
      </Fade>
    </div>
  );
}

export default Sideward;
